import { createReducer } from 'src/helpers/reducer';
import { ILoadDataSuccessPayload, IAttentionRequiredState } from './types';
import actionsTypes from './actionTypes';

const initState: IAttentionRequiredState = {
  // @TODO - add proper items
  items: undefined,
  isLoading: false,
  total: 0,
};

function onLoadTimesheetsRequest(state: IAttentionRequiredState): IAttentionRequiredState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadTimesheetsSuccess(
  state: IAttentionRequiredState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IAttentionRequiredState {
  const { items, total, filteredTotal } = payload;

  return {
    ...state,
    items,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadTimesheetsError(state: IAttentionRequiredState) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_ATTENTION_REQUIRED_REQUEST]: onLoadTimesheetsRequest,
  [actionsTypes.LOAD_ATTENTION_REQUIRED_SUCCESS]: onLoadTimesheetsSuccess,
  [actionsTypes.LOAD_ATTENTION_REQUIRED_ERROR]: onLoadTimesheetsError,
});
